import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { BaseSharedService } from '../base-shared/base-shared.service';
import { BaseComponent } from '../base/base.component';
import { ModalOptions, NzModalService } from 'ng-zorro-antd/modal';
import { ModalDetalheComponent } from './components/modal-detalhe/modal-detalhe.component';

export enum TiposArquivosEnum {
  IMAGEM = '.jpg,.png,.jpeg,.bmp',
  ARQUIVO = '.pdf,.xls,.xlsx,.csv'
}
@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.scss']
})
export class UploadComponent extends BaseComponent implements OnChanges {

  @Input() titulo: string = 'Upload de Arquivos';
  @Input() tiposAceito: any;
  @Input() multiple: boolean = true;
  @Input() somenteLeitura: boolean = false;
  @Input() habilitarExclusaoEmLote: boolean = false;
  @Input() roupaId?: number;

  selectAllFileList: boolean = false;
  selectAllImagensList: boolean = false;
  descricaoGeralInterna: any;
  descricaoGeralExterna: any;

  constructor(
    baseSharedService: BaseSharedService,
    protected override modalService: NzModalService,) {

    super(baseSharedService);
    this.verificarAcaoAtual();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.uploadSharedDataService.imagensList$.subscribe(res => {
      if (res?.length > 0) {
        this.imagensList = res.length ? res : [res]
      }
    });
  }

  verificarAcaoAtual() {
    this.visualizar = this.router.url.includes('visualizar');
  }

  removeItem(item: any) {
    const index = this.fileList.indexOf(item);
    this.fileList.splice(index, 1);
    this.uploadSharedDataService.setFileList(this.fileList);
  }

  // editItemBlur(item: any) {
    // const objEnvio = this.parseToObjEnvio(item);

    // this.uploadService.updateDetalhes(item.id, objEnvio).subscribe({
    //   next: (val: any) => {
    //     this.notificationService.success("Sucesso!", "Descrição salva com sucesso!");
    //   }
    // })
  // }

  salvarListaUpload(lista: any[]) {
    const objEnvio = lista.map((fl: any) => this.parseToObjEnvio(fl));

    this.uploadService.updateDetalhesBatch(objEnvio).subscribe({
      next: (val: any) => {
        this.notificationService.success("Sucesso!", "Descrição salva com sucesso!");
      }
    })
    
  }

  editarSelecionados(lista: any[], novaDescricao: string) {
    lista
      .filter(i => i.selected)
      .forEach(i => i.descricao = novaDescricao);
  }

  removeSelectedImages() {
    if (!this.habilitarExclusaoEmLote) {
      return;
    }

    const selecionadas = this.imagensList?.filter(i => i.selected) ?? [];

    if (!selecionadas.length) {
      this.notificationService.warn('Atenção!', 'Selecione ao menos uma imagem para remover.');
      return;
    }

    this.dialogService.confirm(`Tem certeza de que deseja remover ${selecionadas.length} imagem(ns) selecionada(s)?`, () => {
      const imagensNovas = selecionadas.filter((imagem: any) => imagem?._novaImagemUpload);
      const imagensVinculadas = selecionadas.filter((imagem: any) => !imagem?._novaImagemUpload);
      const ids = imagensVinculadas
        .map(i => i['id'])
        .filter((id: any) => id !== undefined && id !== null);

      if (!ids.length) {
        this.imagensList = this.imagensList.filter(i => !i.selected);
        this.uploadSharedDataService.setImagensList(this.imagensList);
        this.notificationService.success('Sucesso!', 'Imagem(ns) removida(s) da lista com sucesso.');
        return;
      }

      if (!this.roupaId) {
        this.notificationService.warn('Atenção!', 'Salve a roupa antes de excluir imagens já vinculadas.');
        return;
      }

      this.uploadService.removerSelecionados(this.roupaId!, ids).subscribe({
        next: (res: any) => {
          this.imagensList = this.imagensList.filter(i => !i.selected);
          this.uploadSharedDataService.setImagensList(this.imagensList);
          this.notificationService.success('Sucesso!', res?.mensagem ?? 'Imagem(ns) removida(s) com sucesso.');
        }
      });
    });
  }

  parseToObjEnvio(item: any) {
    return {'descricao': (item?.descricao ?? '').trim() || null, 'id': item.id}
  }

  toggleAllSelection(event: any, origin: any[]) {
    origin.forEach(f => f.selected = event);
  }

  modalDescricao(item: any) {
    const index = this.imagensList.findIndex((x: any) => x.id == item);

    const config: ModalOptions<ModalDetalheComponent> = {
      nzTitle: 'Detalhes da Imagem',
      nzContent: ModalDetalheComponent,
      nzWidth: '70vw',
      nzCentered: true,
      nzFooter: null,
      nzMaskClosable: false,
      nzClosable: false,
    };

    const modalRef = this.modalService.create(config);
    modalRef.componentInstance!.lista = this.imagensList;
    modalRef.componentInstance!.index = index;
    modalRef.componentInstance!.somenteLeitura = this.modoSomenteLeitura;

    modalRef.afterClose.subscribe((res: { id: number; descricao: string | null } | undefined) => {
      if (!res) {
        return;
      }

      const imagem = this.imagensList?.find((x: any) => x.id === res.id);
      if (imagem) {
        imagem.descricao = res.descricao ?? undefined;
        this.uploadSharedDataService.setImagensList(this.imagensList);
      }
    });
  }

  get allSelected(): boolean {
    return this.imagensList?.length > 0 && this.imagensList.every(item => item.selected);
  }

  get hasSelectedImages(): boolean {
    return this.imagensList?.some(item => item.selected);
  }

  get modoSomenteLeitura(): boolean {
    return this.visualizar || this.somenteLeitura;
  }
}
